import { useGetQuery } from "hooks";
import { Box, Card as FancyCard, Icon, Link, Title } from "components";


const Card = ({ children, className }) => {
  return (
    <Box margin="0.5rem 1rem">
      <FancyCard className={className}>
        <Box css="display:flex;align-items: center;" margin="0.5rem">
          {children}
        </Box>
      </FancyCard>
    </Box>
  );
};

export const Admin = () => {
  const { data } = useGetQuery({ url: "/admin/users" });
  const locations = useGetQuery({ url: "/admin/locations" });
  const dungeons = useGetQuery({ url: "/admin/dungeons?limit=1" });
  const betaSignups = useGetQuery({ url: "/admin/beta_signups" });
  return (
    <>
      <Link to="/admin/users">
        <Card className="link">
          <Icon icon="account-outline" width="32" height="32" />
          <Box margin="0 0.5rem" css="justify-content: center;"></Box>
          <Title level="4">{data?.users?.count} users.</Title>
        </Card>
      </Link>
      <Link to="/admin/places">
        <Card className="link">
          <Icon icon="office-building-outline" width="32" height="32" />
          <Box margin="0 0.5rem" css="justify-content: center;"></Box>
          <Title level="4">
            {locations?.data?.locations?.count} locations.
          </Title>
        </Card>
      </Link>
      <Link to="/admin/dungeons">
        <Card className="link">
          <Icon icon="map-outline" width="32" height="32" />
          <Box margin="0 0.5rem" css="justify-content: center;"></Box>
          <Title level="4">
            {dungeons?.data?.dungeons?.count ?? "…"} dungeons.
          </Title>
        </Card>
      </Link>
      <Link to="/admin/npcs">
        <Card className="link">
          <Icon icon="account-group-outline" width="32" height="32" />
          <Box margin="0 0.5rem" css="justify-content: center;"></Box>
          <Title level="4">NPCs.</Title>
        </Card>
      </Link>
      <Link to="/admin/quests">
        <Card className="link">
          <Icon icon="clipboard-list-outline" width="32" height="32" />
          <Box margin="0 0.5rem" css="justify-content: center;"></Box>
          <Title level="4">Quests.</Title>
        </Card>
      </Link>
      <Link to="/admin/beta_signups">
        <Card className="link">
          <Icon icon="email-outline" width="32" height="32" />
          <Box margin="0 0.5rem" css="justify-content: center;"></Box>
          <Title level="4">{betaSignups?.data?.beta_signups?.filter(s => s.status !== 'used').length ?? '…'} beta signups.</Title>
        </Card>
      </Link>
      <Link to="/admin/feature_flags">
        <Card className="link">
          <Icon icon="flag-outline" width="32" height="32" />
          <Box margin="0 0.5rem" css="justify-content: center;"></Box>
          <Title level="4">Feature flags.</Title>
        </Card>
      </Link>
    </>
  );
};
